(function(){
    'use strict';

    angular.module('Services').factory('ViewChangeNotificationFactory', ViewChangeNotificationFactory);
    function ViewChangeNotificationFactory(toastr) {
        var vc = this;
        vc.showNofication = function(isViewMode) {
            $('.toast').remove();
            if(isViewMode) {
                toastr.info("You are now in view mode.");
            } else {
                toastr.info("You are now in edit mode.");
            }
        }
        return vc;
    }
})();


// WEBPACK FOOTER //
// ./js/services/UX/ViewChangeNotificationFactory.js